import { useEffect, useState } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

const MyProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const influencerId = localStorage.getItem("influencerID");
  const skeletonCount = 6;

  const fetchProducts = async () => {
    setLoading(true);
    const startTime = Date.now();
    const minLoadTime = 3000; // 3 seconds

    try {
      const res = await axios.get(`https://server-side-influencer.onrender.com/influencer/product/${influencerId}`);
      setProducts(res.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      const elapsed = Date.now() - startTime;
      const waitTime = minLoadTime - elapsed;
      if (waitTime > 0) {
        setTimeout(() => setLoading(false), waitTime);
      } else {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gray-100 text-black flex items-center justify-between p-4 fixed w-full top-0 left-0 z-50 shadow">
        <div onClick={() => navigate(-1)} className="cursor-pointer flex items-center">
          <IoArrowBack size={24} />
          <span className="ml-2">Back</span>
        </div>
        <div className="text-right font-semibold text-lg">my Post</div>
      </div>

      {/* Content */}
      <div className="flex-1 p-6 pt-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {loading
            ? Array.from({ length: skeletonCount }).map((_, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-2xl shadow-md overflow-hidden p-4"
                >
                  <Skeleton height={192} className="mb-2" />
                  <Skeleton height={20} width={`80%`} className="mb-1" />
                  <Skeleton height={15} width={`60%`} className="mb-3" />
                  <Skeleton height={15} width={100} />
                </div>
              ))
            : products.map((product) => (
                <div
                  key={product._id}
                  className="bg-white rounded-2xl shadow-md overflow-hidden transition duration-300 hover:shadow-xl"
                >
                  <img
                    src={product.image}
                    alt={product.customTitle || "Product Image"}
                    className="w-full h-48 object-fit-cover"
                  />
                  <p className="text-sm text-gray-600 mt-2 truncate px-4">
                    {product.caption || "No caption"}
                  </p>
                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-900">
                      {product.customTitle || "No Title"}
                    </h3>
                    <a
                      href={product.shareableLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block mt-3 text-blue-600 hover:underline text-sm"
                    >
                      Visit Link
                    </a>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default MyProducts;
